<template lang='pug'>
  r-table(
    :no-actions="!$can('VIEW_DETAIL_SALE_TICKET')"
    no-data-text='Sin tickets de venta.'
    no-remove
    param-search='number'
    ref='table'
    remind-key='pos-sale-pending-list'
    v-bind='tableProps'
    @detail='submitShow'
    )
    template( slot="actions" slot-scope="props" )
      v-btn-action( 
        color='info' 
        :disabled='props.item.pos_sale_authorizations_reasons.length == 0'
        tooltip='Razones de autorización' 
        @click="submitReasons(props)" 
        )
        v-icon info
      v-btn-action( 
        color='success' 
        :disabled='!props.item.can_authorize'
        tooltip='Autorizar' 
        @click="submitAuthorize(props)" 
        )
        v-icon check_circle
      v-btn-action( 
        color='error' 
        :disabled='!props.item.can_cancel'
        tooltip='Anular' 
        @click="cancelTicket(props.item)" 
        )
        v-icon cancel
</template>

<script>
  //-
  import { mapActions, mapState } from 'vuex'
  import { RTable, VBtnAction } from '@/components/reusable_components/next'
  //
  import translatorService from '@/services/translator'
  import PosSaleModel from '@/models/POS/PosSale'
  import filters from './filters'
  import headers from './headers'
  //-
  export default {
    name: 'pos-sale-pending',
    components: {
      RTable,
      VBtnAction,
    },
    data() {
      return {
        loading: false,
        ticketToCancel: null,
      }
    },
    computed: {
      ...mapState('AuthModule', ['user']),
      ...mapState('SnackbarModalModule', {
          responseConfirm: 'responseConfirm',
      }),
      tableProps() {
        return {
          service: PosSaleModel,
          filters: filters({
            g_branch_office_address: this.user.hr_employee.g_branch_office.address,
          }),
          paramFilter: {
            //needs_authorization: true,
          },
          initialFilterValues: {
            //created_at_min: new Date().toISOString().substring(0, 10),
          },
          headers,
        }
      },
    },
    methods: {
      cancelTicket(posSale) {
        this.loading = true
        this.ticketToCancel = posSale
        this.resetSnackbarState()
        this.setMessageConfirmSnack('ANULAR')
        this.showSnackbar(
            'warning',
            'Advertencia',
            `¿Desea anular el ticket de venta n°${posSale.id} ?`
        )
      },
      async showSnackbar(type, title, message, callback = () => {}) {
        this.initSnackbar(this.fillSnack(type, title, message, false, 0))
        callback()
      },
      ...mapActions('MenuesModule', {
        setTitleTopBar: 'setTitleTopBar',
      }),
      ...mapActions('SnackbarModalModule', {
        initSnackbar: 'initSnackbar',
        hideSnack: 'hideSnack',
        resetSnackbarState: 'resetSnackbarState',
        setMessageConfirmSnack: 'setMessageConfirmSnack',
      }),
      showErrorAuthorize(event) {
        this.showErrorSnackbar(translatorService(PosSaleModel, event.response.data))
      },
      showSuccessAuthorize() {
        this.showSuccessSnackbar('Ticket de venta autorizado exitosamente.')
      },
      submitReasons(event) {
        this.showInfoSnackbar(event.item.pos_sale_authorizations_reasons_text)
      },
      submitShow(event) {
        this.$router.push({
            name: 'sale-ticket-detail',
            params: { id: event.item.id },
        })
      },
      submitAuthorize(event) {
        //
        this.selected = event.item
        //
        this.showWarningSnackbar({
          title: 'Autorizar',
          message: '¿Desea autorizar el ticke de venta?',
          confirm: 'autorizar'
        })
      },
      toAuthorize() {
        return this
          .selected
          .authorize()
          .attach()
          .then(this.showSuccessAuthorize)
          .then(this.toRefresh)
          .catch(this.showErrorAuthorize)
      },
      toRefresh() {
        this
          .$refs
          .table
          .refresh()
      },
    },
    watch: {
      responseConfirmSnackbar(value) {
        switch(value) {
          case 'autorizar': return this.toAuthorize()
        }
      },
      async responseConfirm(message) {
        switch (message) {
          case 'ANULAR':
            this.ticketToCancel
                .delete()
                .then(r => {
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito',
                        'Ticket anulado exitosamente'
                    )
                    //
                    this.$nextTick(() => this.$refs.table.refresh())
                    this.ticketToCancel = null
                })
                .catch(e => {
                    let message =
                        e.response &&
                        e.response.data &&
                        e.response.data.message
                            ? e.response.data.message
                            : e.response &&
                              e.response.data &&
                              e.response.data.error
                            ? e.response.data.error
                            : e
                    this.resetSnackbarState()
                    this.showSnackbar('error', 'Error', message)
                })
                .finally(() => (this.loading = false))
        }
      },
    },
    beforeMount() {
      this.setTitle('Tickets de venta pendientes')
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_SALE_TICKET')) ctx.$router.push('/')
      })
    },
  }
</script>
